import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IOrgRoleDetail } from "interfaces";
import { EditRoleForm } from "./components/editRoleForm";

export const EditOrgRole : React.FC = () => {

  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IOrgRoleDetail>({
    resource: "organization/role",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const orgRoleDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Org's Role" />
      {orgRoleDetailData ? <EditRoleForm orgRole={orgRoleDetailData} id={params?.id} /> : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}